export default __webpack_public_path__ + "static/media/webPortfolioHrs.471275b8.png";